<script>
    import FormSavingButtons from '../FormSavingButtons.svelte'
    import FormAlerts from '../FormAlerts.svelte'
    import keyBy from '@fno/lib/key-by.js'
    import schema from 'fanx-schema/resource/taskTabTool'
    import stepIdToRoute from '@fno/route/hello/step-id-to-route.js'

    const stepIdToStep = keyBy(schema.properties.steps.fragments, 'id')
    const staticAssetPrefix = (window.fanxVersion && window.fanxVersion.urlPrefix) || '/'

    export let context
    export let saving
    export let asr
    export let schoolId

    $: incompleteSteps = Object.values(context.form.clientOnboarding.attributes.steps).filter(
        (step) => step.status !== 'COMPLETED'
    )
</script>

<div class="d-flex justify-content-center mb-5">
    <img style="height: 150px;" alt="You are done!" src="{staticAssetPrefix}img/onboarding/finish-graphic.png" />
</div>

{#if !incompleteSteps.length}
    <p>
        Thank you for taking the first steps in configuring your app! Please make sure all of the steps are completed
        with the requested information before you Save and Complete.
    </p>
    <p>
        Upon Saving and Completing the T.A.B. you will be redirected to your Portal. The next step in the implementation
        process will be to attend both Portal Basics and Promotions Training. Registration links can be found below.
        These links can also be accessed any time via the “Help” section of the Portal.
    </p>
    <ul>
        <li>
            <a
                href="https://fromnowon.freshdesk.com/support/solutions/articles/35000109813-portal-basics-training"
                target="_blank"
            >
                Register for Live Portal Basics Training
            </a>
        </li>
        <li>
            <a
                href="https://fromnowon.freshdesk.com/support/solutions/articles/35000109814-promotions-training"
                target="_blank"
            >
                Register for Live Promotions Training
            </a>
        </li>
    </ul>
    <p>
        If the available times for training do not work with your schedule contact your Customer Success Coach and they
        will coordinate a training time that works well for you and your team.
    </p>
{:else}
    <p>You are almost done! Only a few more pages to go check and mark as completed:</p>
    <ul>
        {#each incompleteSteps as step}
            <li><a href={asr.makePath(stepIdToRoute[step.id], { schoolId })}> {stepIdToStep[step.id].label} </a></li>
        {/each}
    </ul>
{/if}

<FormAlerts bind:alerts={context.alerts} />

<FormSavingButtons
    lastPage
    disableNext={incompleteSteps.length}
    {context}
    {saving}
    on:save
    on:nextStepClicked
    on:previousStepClicked
/>
